import React from 'react';
import { useScope } from './ScopeProvider';
import './ScopeSelector.css';

/**
 * O seletor de escopo (§9.3): "configurando para quem?", respondido UMA vez para todas as abas.
 *
 * Por que os overrides de loja são entradas de primeira classe, e não um segundo select: escondidos
 * atrás de outro campo, eles ficam invisíveis. Foi assim que os 16 overrides de prompt da
 * leroymerlin passaram desapercebidos até alguém consultar o banco. Aqui eles aparecem na lista e
 * dá para contar quantos existem.
 */
function ScopeSelector() {
    const { companies, subdomain, setSubdomain, opcoes, valorAtual, selecionar, loading } = useScope();

    const porGrupo = opcoes.reduce((acc, o) => {
        const g = o.grupo || '';
        (acc[g] = acc[g] || []).push(o);
        return acc;
    }, {});
    const atual = opcoes.find((o) => o.value === valorAtual);

    return (
        <div className="scope-selector">
            <label className="scope-campo">
                <span>Empresa</span>
                <select value={subdomain} onChange={(e) => setSubdomain(e.target.value)}>
                    {companies.map((c) => (
                        <option key={c.subdomain} value={c.subdomain}>{c.name || c.subdomain}</option>
                    ))}
                </select>
            </label>

            <label className="scope-campo scope-campo-largo">
                <span>Escopo</span>
                <select
                    value={valorAtual}
                    disabled={loading}
                    onChange={(e) => {
                        const op = opcoes.find((o) => o.value === e.target.value);
                        if (op) selecionar(op.scope);
                    }}
                >
                    {(porGrupo[''] || []).map((o) => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                    {(porGrupo['Lojas'] || []).length > 0 && (
                        <optgroup label={`Lojas (${porGrupo['Lojas'].length})`}>
                            {porGrupo['Lojas'].map((o) => (
                                <option key={o.value} value={o.value}>{o.label}</option>
                            ))}
                        </optgroup>
                    )}
                    {(porGrupo['Fases'] || []).length > 0 && (
                        <optgroup label={`Fases (${porGrupo['Fases'].length})`}>
                            {porGrupo['Fases'].map((o) => (
                                <option key={o.value} value={o.value}>{o.label}</option>
                            ))}
                        </optgroup>
                    )}
                </select>
            </label>

            <div className="scope-explicacao">
                {atual?.value === 'ongoing' && (
                    <span>Vale para a empresa toda, exceto onde uma loja ou uma fase sobrescrever.</span>
                )}
                {atual?.value?.startsWith('store:') && (
                    <span>Sobrescreve o padrão da empresa <strong>nesta loja</strong>.</span>
                )}
                {atual?.value?.startsWith('phase:') && (
                    <span>
                        Sobrescreve loja e empresa <strong>enquanto o vendedor estiver nesta fase</strong>.
                        {atual.locks_scoreboard === false && (
                            <em> Esta fase não trava o placar, então não aceita régua de pontuação própria.</em>
                        )}
                    </span>
                )}
            </div>
        </div>
    );
}

export default ScopeSelector;
